import {
  QUICK_SEARCH_QUERY,
  QUICK_SEARCH_RECEIVE,
  QUICK_SEARCH_SHOW,
  QUICK_SEARCH_SELECT_ITEM,
} from '../constants';

const DEFAULT_STATE = {
  query: '',
  result: {
    products: [],
    results: [],
  },
  show: false,
  selectedItem: -1,
  popularSearches: [],
  popularLinks: [],
};

export const quickSearch = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case QUICK_SEARCH_QUERY: {
      // Only update if query actually changed
      if (state.query === action.payload.query) {
        return state;
      }
      return {
        ...state,
        query: action.payload.query,
      };
    }

    case QUICK_SEARCH_RECEIVE: {
      // Build new state only with changed fields
      const newState = { ...state };
      let hasChanges = false;

      if (
        action.payload.result !== undefined &&
        state.result !== action.payload.result
      ) {
        newState.result = action.payload.result;
        hasChanges = true;
      }

      if (
        action.payload.show !== undefined &&
        state.show !== action.payload.show
      ) {
        newState.show = action.payload.show;
        hasChanges = true;
      }

      if (
        action.payload.popularSearches !== undefined &&
        state.popularSearches !== action.payload.popularSearches
      ) {
        newState.popularSearches = action.payload.popularSearches;
        hasChanges = true;
      }

      if (
        action.payload.popularLinks !== undefined &&
        state.popularLinks !== action.payload.popularLinks
      ) {
        newState.popularLinks = action.payload.popularLinks;
        hasChanges = true;
      }

      // Only return new state if something actually changed
      return hasChanges ? newState : state;
    }

    case QUICK_SEARCH_SHOW: {
      // Only update if show state actually changed
      if (state.show === action.payload.show) {
        return state;
      }
      return {
        ...state,
        show: action.payload.show,
      };
    }

    case QUICK_SEARCH_SELECT_ITEM: {
      // Only update if selected item actually changed
      if (state.selectedItem === action.payload.selectedItem) {
        return state;
      }
      return {
        ...state,
        selectedItem: action.payload.selectedItem,
      };
    }

    default:
      return state;
  }
};
